module.exports = "<footer class=\"wb-footer\">\n  <p>&copy;{{year}} {{'webpanel.main.footer_text'|translate|capitalizeFirst}}</p>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/footer.component.html
// module id = ./src/app/shared/layout/footer.component.html
// module chunks = main